// Module
var code = `<div class="rb-element rb-break rb-print clearfix"></div>`;
// Exports
export default code;